import { Coordinates } from "@/components/atoms/Map/Map";
import { getGoogleApiKey } from "@/helpers/apiHelpers";

type SnappedPointsResponse = {
  snappedPoints?: Array<{ location: { latitude: number; longitude: number } }>;
};

/**
 * Snap a coordinate to the nearest drivable road via the Google Roads API (mobile parity with
 * `getNearestRoad`). Degrades gracefully: returns the input coordinate on any error/empty result,
 * so a missing Roads API entitlement never breaks selecting/pinning a location.
 */
export const snapToNearestRoad = async (coords: Coordinates): Promise<Coordinates> => {
  try {
    const url = `https://roads.googleapis.com/v1/nearestRoads?points=${coords.lat},${coords.lng}&key=${getGoogleApiKey()}`;
    const response = await fetch(url);
    if (!response.ok) return coords;
    const data: SnappedPointsResponse = await response.json();
    const snapped = data?.snappedPoints?.[0]?.location;
    return snapped ? { lat: snapped.latitude, lng: snapped.longitude } : coords;
  } catch {
    return coords;
  }
};
